import { cloneDeep } from 'lodash'

import { extractDatePart } from './time'

import { FeesTypeItem, RegistrationFeesType } from '../models/event-fees/event-fees.interface'
import { TCustomSchedule } from '../models/event-scheduling/event-scheduling.interface'
import { IRegistrationTabs } from '../models/event-registered-users/event-registered-users.interface'
import { IRegistrationFeesInterface } from '../models/registration-fees/registrationFees.interface'

export const getAllRegistrationFees = (registrationFees: RegistrationFeesType[]) => {
  const flattenedFees = registrationFees.flatMap((item: RegistrationFeesType) => {
    if (item?.children?.[0]) return [...item.children]
    return [item]
  })

  return flattenedFees ?? []
}

export const getGroupFeesByDayAndFacility = (fees: (FeesTypeItem | TCustomSchedule)[]) => {
  const classesByDayFacility: Record<string, { fees: (FeesTypeItem | TCustomSchedule)[] }> = {}

  fees.forEach((fee) => {
    const dayKey = extractDatePart(fee.startDate)
    const facility = fee.location || 'No Facility Assigned'
    const groupKey = `${dayKey}_${facility}`

    if (!classesByDayFacility[groupKey])
      classesByDayFacility[groupKey] = {
        fees: [],
      }

    if (fee.uuid) classesByDayFacility[groupKey].fees.push(fee)
  })

  return classesByDayFacility
}
export function mergeFeesWithTabData({
  feesTabData,
  registrationFees,
}: {
  feesTabData: IRegistrationTabs['IFeesTab'][]
  registrationFees: IRegistrationFeesInterface[]
}) {
  let feesTabDataCloned = cloneDeep(feesTabData)

  // Remove all registrationFees
  feesTabDataCloned = feesTabDataCloned.map((currRow) => {
    return {
      ...currRow,
      registrationFees: null,
    }
  })

  feesTabDataCloned = feesTabDataCloned.map((currRow) => {
    let foundRegistrationFees = cloneDeep(registrationFees).filter(
      (currRegistrationFees) => currRegistrationFees.feesItemId === currRow.feesItemId
    )

    return {
      ...currRow,
      registrationFees: foundRegistrationFees[0]
        ? {
            ...foundRegistrationFees[0],
            selectedUnitsCount: foundRegistrationFees.length || 0,
          }
        : null,
    }
  })

  return feesTabDataCloned
}
